import React, { useContext } from "react";
import { Link } from "gatsby";
// import PubSub from "pubsub-js"

import { LocaleContext } from "./LocaleWrapper";
const locales = require("../../../config/i18n");

const LocaleSwitcher = () => {
  const _LocaleContext = useContext(LocaleContext);
  const { localeCtx, dispatch } = _LocaleContext;
  // console.log(_LocaleContext)

  const renderLanguages = () => {
    const languages = Object.values(locales).map((li, i) => {
      let _className = li.locale === localeCtx ? "active" : "";
      const path = li.default ? `/` : `/${li.path}`;

      // console.log(key);
      const isLast = i + 1 === Object.values(locales).length;
      _className += isLast ? "is-last" : "";

      return (
        <li key={`locale-${i.toString()}`} className={`${_className} ttu`}>
          <Link
            to={path}
            // className={`${_className} ttu`}
            onClick={() => dispatch(li.locale)}>
            {li.label}
          </Link>
        </li>
      );
    });
    return languages;
  };

  return <ul className='locale-switcher x'>{renderLanguages()}</ul>;
};

export default LocaleSwitcher;
